module.exports = __webpack_public_path__ + "img/schedule_pin.c35bd5e3.svg";